import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import { errorConditionGTM } from "../../../Utils/googleTags";
import ApiUrls from "../../../Utils/axr";

type contentDetailsInitialStateType = {
  layoutContent: any;
  loading: boolean;
  error: any;
};
const initialState: contentDetailsInitialStateType = {
  layoutContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = "header-nav.json";

export const getLayoutContent = createAsyncThunk(
  "get/layout/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const layoutContentDetailSlice = createSlice({
  name: "layout/content/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLayoutContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLayoutContent.fulfilled, (state, action) => {
      state.layoutContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getLayoutContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "layout AEM content",
        action.error?.message,
        action?.type
      );
      state.layoutContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default layoutContentDetailSlice.reducer;
